import { render, staticRenderFns } from "./gameserverbatchadd.vue?vue&type=template&id=47741988&scoped=true"
import script from "./gameserverbatchadd.vue?vue&type=script&lang=js"
export * from "./gameserverbatchadd.vue?vue&type=script&lang=js"
import style0 from "./gameserverbatchadd.vue?vue&type=style&index=0&id=47741988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47741988",
  null
  
)

export default component.exports